import { IHttpClient } from "../../../lib/http";
import { CampingMapDTO, CampingMapEntity } from "./campingMap.dto";
import { dtoToEntity, entityToDto } from "./campingMap.mapper";

export const useCampingMapApi = (httpClient: IHttpClient) => {
  return {
    getCampingMap: (propertyTicker: string) => getCampingMap(httpClient, propertyTicker),
    updateCampingMap: (propertyTicker: string, entity: CampingMapEntity) =>
      updateCampingMap(httpClient, propertyTicker, entity),
  };
};

async function getCampingMap(
  httpClient: IHttpClient,
  propertyTicker: string
): Promise<CampingMapEntity> {
  const params = new URLSearchParams();
  params.append("prop", "unitSelectionMapConfiguration");
  const dto = await httpClient.get<CampingMapDTO>(
    `/WitBookerAPI-war/webresources/endpoint/establishment/${propertyTicker}/configurations`,
    { params }
  );
  return dtoToEntity(dto);
}

async function updateCampingMap(
  httpClient: IHttpClient,
  propertyTicker: string,
  entity: CampingMapEntity
): Promise<void> {
  await httpClient.post(
    `/WitBookerAPI-war/webresources/endpoint/establishment/${propertyTicker}/createOrUpdateConfigurations`,
    entityToDto(entity)
  );
}
